import styled from "styled-components";
import { VARIANTS } from "constants/Typography";

type TableWrapperPropsType = {
  isBlurContent?: boolean;
};

export const TableWrapper = styled.div<TableWrapperPropsType>`
  min-height: 450px;
  max-height: 600px;
  position: relative;
  overflow: auto;
  overflow: ${({ isBlurContent }) => (isBlurContent ? "hidden" : "auto")};
  -ms-overflow-style: none;
  line-height: 1rem;
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    display: initial;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(83, 83, 83, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  .table {
    width: 100%;
    font-size: ${VARIANTS.body4.size};

    input[type="checkbox"] {
      width: 24px;
      height: 24px;
    }

    .header {
      .th {
        padding: 16px 10px;
        border-bottom: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        background-color: white;
        color: ${({ theme }) => theme.COLORS.DarkLight};
        font-weight: 600;
        border-top: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        word-break: break-word;

        svg {
          font-size: 20px;
        }

        :first-child {
          border-left: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        }

        :last-child {
          border-right: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        }
      }
    }

    .footer {
      .th {
        padding: 16px 10px;
        border-bottom: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        background-color: white;
        color: ${({ theme }) => theme.COLORS.DarkLight};
        font-weight: 600;
        word-break: break-word;

        :first-child {
          border-left: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        }

        :last-child {
          border-right: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
        }
      }
    }

    .td {
      padding: 10px;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
      background-color: white;
      color: ${({ theme }) => theme.COLORS.DarkGray};
      word-break: break-word;

      :first-child {
        border-left: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
      }

      :last-child {
        border-right: 0;

        border-right: 1px solid ${({ theme }) => theme.COLORS.LightBlue};
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    }

    &.sticky {
      .header {
        position: sticky;
        z-index: 0;
        top: 0;
        left: 0;
        box-shadow: 0px 1px 3px 0px ${({ theme }) => theme.COLORS.LightBlue};
      }

      .footer {
        position: sticky;
        z-index: 0;
        bottom: 0;
        box-shadow: 0px -1px 3px 0px ${({ theme }) => theme.COLORS.LightBlue};
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px ${({ theme }) => theme.COLORS.LightBlue};
        border-right: 1px solid #ddd;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px ${({ theme }) => theme.COLORS.LightBlue};
      }
    }
  }
`;
